import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { DataService } from '../../dataService';
import { IReportsFilterModel } from '../../models/reports-filter.models';
import { ReportsActivityRoutes, typeReportsActivityRoutes } from '../../models/reports.models';
import { ReportService } from '../../reportService';

@Component({
    selector: 'app-activity-reports',
    templateUrl: './activity-reports.component.html',
    styleUrls: ['./activity-reports.component.scss']
})
export class ActivityReportsComponent implements OnInit, OnDestroy {

    //#region Properties

    public selectedWindow: string = '';
    public reportName: string = '';
    public dateFrom: any;
    public dateTo: any;
    public reportDate: Date = new Date();
    public pageSize: number = 0;
    public pageNumber: number = 15;


    public cols: any;
    public reportsData = [];
    public totalRecords: number;
    public totalPages: number;
    public results = [];
    public IsShowReportTemplate: boolean = true;
    public noContactFindOrLoadingText = 'Loading....';
    dataPassed: any;
    //#endregion

    //CTOR

    subscription: Subscription = new Subscription();
    constructor(public app: AppMainComponent,
        private appMainService: AppMainService,
        private reportService: ReportService,
        private router: ActivatedRoute,
        private dataService: DataService
    ) {
        this.subscription = this.dataService.getData().subscribe(data => {
            this.onGlobalSearch(data);
        });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    ngOnInit(): void {
        this.subscription = this.router.paramMap.subscribe((param: any) => {
            const activityType: typeReportsActivityRoutes = param.params.type;
            switch (activityType) {
                case ReportsActivityRoutes.activityAnalyticReportSummary:
                    this.selectedWindow = "activityAnalyticReportSummary";
                    break;
                case ReportsActivityRoutes.activityAnalyticReportDetail:
                    this.selectedWindow = "activityAnalyticReportDetail";
                    break;
                case ReportsActivityRoutes.outboundCallReport:
                    this.selectedWindow = "outboundCallReport";
                    break;
                case ReportsActivityRoutes.outboundCallRequired:
                    this.selectedWindow = "outboundCallRequired";
                    break;
                case ReportsActivityRoutes.inboundCallReport:
                    this.selectedWindow = "inboundCallReport";
                    break;
                case ReportsActivityRoutes.top10ActivityUser:
                    this.selectedWindow = "top10ActivityUser";
                    break;

                default:
                    break;
            }
            this.ActivityReport(0, this.app.companyId, this.app.userId, 15, 1, this.selectedWindow, null, this.app.companyId);
        });
    }

    ActivityReport(selectedChannelId: number, companyId: number, userId, currentPageSize: number = 15, currentPageNumber: number = 1, selectedWindow: string, selectedUser: object, selectedOrganizationId: number, searchValue?: any): void {

        this.appMainService.isShowSpinner('ActivityReport');
        //this.displayFilter = (this.selectedRepFilter == undefined) ? 'All' : this.selectedRepFilter.name;

        switch (this.selectedWindow) {
            case 'activityAnalyticReportSummary': {
                this.cols = [
                    { field: 'activityChannel', header: 'Activity Channel' },
                    { field: 'totalCount', header: 'Total Count' },];
                this.reportName = 'Activity Analytic Report Summary';
                break;
            }
            case 'accountsActivityReport': {
                this.cols = [
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'channelType', header: 'Channel Type' },
                    { field: 'comment', header: 'Comment' },
                    { field: 'logdatetime', header: 'Created Date' },
                    { field: 'loggedBy', header: 'Created By' },
                    { field: 'territoryName', header: 'Territory Name' },
                    { field: 'address', header: 'Address' },
                ];

                this.reportName = 'Activity Report';
                break;
            }

            case 'activityAnalyticReportDetail': {
                this.cols = [
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'channelType', header: 'Channel Type' },
                    { field: 'comment', header: 'Comment' },
                    { field: 'loggedBy', header: 'Logged By' },
                    { field: 'activityCreatedDate', header: 'Date & Time' },
                    { field: 'territoryName', header: 'Territory Name' },
                    { field: 'moduleName', header: 'Module Name' },
                    { field: 'address', header: 'Address' },

                ];
                this.reportName = 'Activity Analytic Report Detail';
                break;
            }
            case 'outboundCallReport': {
                this.cols = [
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'accountNumber', header: 'Account Number' },
                    { field: 'callLoggedBy', header: 'Call Logged By' },
                    { field: 'callComment', header: 'Call Comment' },
                    { field: 'activityCreatedDate', header: 'Date & Time' },
                    { field: 'stateName', header: 'State Name' },
                    { field: 'territoryName', header: 'Territory Name' },
                    { field: 'moduleName', header: 'Module Name' },

                ];
                this.reportName = 'Outbound Call Report';
                break;
            }
            case 'outboundCallRequired': {
                this.cols = [
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'accountNumber', header: 'Account Number' },
                    { field: 'logdatetimeUTC', header: 'Last Call Date' },
                    { field: 'callLoggedBy', header: 'Logged By' },
                    { field: 'territoryName', header: 'Territory Name' },
                    { field: 'moduleName', header: 'Module Name' },
                    { field: 'address', header: 'Address' },
                ];
                this.reportName = 'Outbound Call Required';
                break;
            }
            case 'inboundCallReport': {
                this.cols = [
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'accountNumber', header: 'Account Number' },
                    { field: 'callLoggedBy', header: 'Call Logged By' },
                    { field: 'callComment', header: 'Call Comment' },
                    { field: 'activityCreatedDate', header: 'Date & Time' },
                    { field: 'territoryName', header: 'Territory Name' },
                    { field: 'moduleName', header: 'Module Name' },
                ];
                this.reportName = 'Inbound Call Report';
                break;
            }
            case 'top10ActivityUser': {
                this.cols = [
                    { field: 'user', header: 'User' },
                    { field: 'emailSentReplied', header: 'Email Sent / Replied' },
                    { field: 'inboundCall', header: 'Inbound Call' },
                    { field: 'outboundCall', header: 'Outbound Call' },
                    { field: 'fieldVisit', header: 'Field Visit' },
                    { field: 'events', header: 'Events' },

                    { field: 'taskCompleted', header: 'Task Completed' },
                    { field: 'checkIn', header: 'Check In' },
                    { field: 'grandTotal', header: 'Grand Total' },

                ];
                this.reportName = 'Top 10 User Activity';
                break;
            }
            default: {
                break;
            }
        }

        //this.OrganizationName = this.app.user.organizationName;
        this.reportService.AllActivityReport(selectedChannelId, currentPageSize, currentPageNumber,
            this.formatDate(this.dateFrom),
            this.formatDate(this.dateTo), this.selectedWindow,
            selectedUser, null, null, "All", searchValue).then(res => {
                this.reportsData = [];
                this.totalRecords = 0;
                this.results = [];
                this.totalPages = 0;
                let { contacts, headers } = res;
                this.IsShowReportTemplate = true;
                this.appMainService.isHideSpinner('ActivityReport');
                this.reportsData = JSON.parse(JSON.stringify(contacts));

                this.totalRecords = headers['TotalCount'];
                //added for PDF
                this.results = JSON.parse(JSON.stringify(contacts));
                this.totalPages = headers['TotalPages']
                //added for PDF

            }).finally(() => {
                this.appMainService.isHideSpinner('ActivityReport');
                this.noContactFindOrLoadingText = 'No Reports Available.';
            });

    }
    private formatDate(date: Date) {
        return moment(date).format('MM-DD-YYYY');
    }

    onRemoveFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.ActivityReport(0, this.app.companyId, this.app.userId, 15, 1, this.selectedWindow, null, this.app.companyId);
    }

    onClosePanel(selectedWindow: string): void {
    }

    onApplyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.ActivityReport(0, this.app.companyId, this.app.userId, 15, 1, this.selectedWindow, null, this.app.companyId);
    }

    onChangeRange(selectedWindow: string, event: any): void {
        this.ActivityReport(0, this.app.companyId, this.app.userId, 15, 1, this.selectedWindow, null, this.app.companyId);
    }

    onGlobalSearch(searchValue: any) {
        this.ActivityReport(null, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, null, this.app.companyId, searchValue);
    }
}
